import { render, staticRenderFns } from "./EditSubmissionPopup.vue?vue&type=template&id=d9f87962&"
import script from "./EditSubmissionPopup.vue?vue&type=script&lang=js&"
export * from "./EditSubmissionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports